export default "__VITE_ASSET__Cf52cWxH__"